module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2023@2x.2c04c375.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2023@2x.png
// module id = 1158
// module chunks = 0